import { Injectable } from "@angular/core";
import { ModuleConfig } from "@shared-config/moduleConfig";
import { ProductType } from "@shared-model/products/ProductType";

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class DatingModuleConfig extends ModuleConfig {
  constructor() {
    super({
      ProductTypeIdsQueueWithTopups: null,
      ProductTypeIdsCallback: [ProductType.MinutesTopUp],
      ProductTypeIdsIvr: [ProductType.MinutesTopUp],
      ProductTypeIdsIm: null,
      ProductTypeIdsImTopupBundle: null,
      ProductTypeIdsImTopupPayg: null,
      CallbackProductChoiceEnabled: false,
      ProductTypeIdBestOfferIvr: ProductType.MinutesTopUp,
      ProductTypeIdBestOfferIm: null,
      QueueWarningEnabled: false,
      ExpertsSupported: false,
      ExpertTariffsSupported: false,
      OnlineChatSupported: false,
      ManageCardsFunctionalitySupported: true,
      UrlCreateAccount: '/Register/',
      UrlManageCards: '/AccountSettings/ManageCards/',
      UrlRegisterCardAndPay: '/Register-Card-And-Pay/',
      UrlForgotPassword: '/Login/ForgotPassword/',
      FormFieldUsernameName: 'Mobile',
      FormFieldUsernameCanOnlyBeEmail: false,
      GoogleAnalyticsFunctionalitySupported: true,
    });
  }
}
